
import axios from 'axios'
import config from 'react-observable-store'
import Cookies from 'universal-cookie'

/**
 * Auth model
 *
 * Responsible to comunicate with remote server
 * @type {String}
 */
const AuthModel = {

    /**
     * Server base endpoint
     * @type {String}
     */
    endpoint: () => {
        return config.get('globals').auth.endpoint
    },

    /**
     * Set logged user
     * @param {[type]} user [description]
     */
    setLoggedUser: (user) => {
        var policy = {}, action = {}, permissions = []
        user.permissions.forEach((perm) => {
            action = {
                a: perm.schema,
                b: perm.action,
                c: perm.access,
                p: []
            }
            perm.policies.forEach((pol) => {
                policy = {
                    n: pol.sysname,
                    p1: pol.param1,
                    p2: pol.param2
                }
                action.p.push(policy)
            })
            permissions.push(action)
        })
        user.permissions = permissions

        // SET COOKIE
        //var expires = 86400000 // 24 hours
        var expires = 72000000 // 20 hours
        //var expires = 10000 // For testing expire purposes
        var d = new Date()
        d.setTime(d.getTime() + expires)
        const cookieHandler = new Cookies()
        cookieHandler.set('siarlrol', user, { path: '/', expires: d })
    },

    /**
     * Get authentication token
     * @return {String} The authentication token
     */
    getAuthToken: () => {
        const cookieHandler = new Cookies()
        const cookie = cookieHandler.get('siarlrol')
        return cookie ? cookie.auth_token : ''
    },

    /**
     * Get logged user
     * @return {Object} The logged user
     */
    getLoggedUser: () => {
        const cookieHandler = new Cookies()
        const cookie = cookieHandler.get('siarlrol')
        return cookie && cookie.id ? cookie : {permissions: []}
    },

    /**
     * Check whether the current user is authenticated
     * @return {Boolean} True or false
     */
    isAuthenticated: () => {
        const cookieHandler = new Cookies()
        const cookie = cookieHandler.get('siarlrol')
        return cookie && cookie.id ? true : false
    },

    /**
     * Store last requested route
     * @type {String}
     */
    lastRoute: '/',

    /**
     * Dispense a new record
     * @return {object} The new record as object
     */
    dispense: () => {
        return {id: '', email: ''};
    },

    /**
     * Login user
     * @param  {Object}     params  The credentials object
     * @param  {Function}   cb Result callback
     * @return {undefined}     Async return
     */
    login: (params, cb) => {
        axios.post(AuthModel.endpoint() + '/login', params)
        .then(res => {
            if (res.status === 200) {

                // Set logged user
                if (res.data.auth_token) {
                    AuthModel.setLoggedUser(res.data)
                }

                // Continue to callback
                cb(res.data);
            }
        });
    },

    /**
     * Logout, remove current cookie
     * @return {[type]} [description]
     */
    logout: () => {
        const cookieHandler = new Cookies()
        cookieHandler.set('siarlrol', {}, { path: '/' });
    },

    /**
     * Recover start
     * @param  {Object}     params  The credentials object
     * @param  {Function}   cb Result callback
     * @return {undefined}     Async return
     */
    recoverStart: (params, cb) => {
        axios.post(AuthModel.endpoint() + '/recover/start', params)
        .then(res => {
            if (res.status === 200) {
                cb(res.data);
            }
        });
    },

    /**
     * Recover password
     * @param  {Object}     params  The credentials object
     * @param  {Function}   cb Result callback
     * @return {undefined}     Async return
     */
    recover: (params, cb) => {
        axios.post(AuthModel.endpoint() + '/recover', params)
        .then(res => {
            if (res.status === 200) {
                cb(res.data);
            }
        });
    },

    /**
     * Register user
     * @param  {object}   todo The record to store
     * @param  {Function} cb   Result callback
     * @return {undefined}     Async return
     */
    register: (user, cb) => {
        axios.post(AuthModel.endpoint() + '/register', user)
        .then(res => {
            if (res.status === 200) {
                cb(res.data);
            }
        });
    }
}

export default AuthModel



// WEBPACK FOOTER //
// ./src/models/AuthModel.js